var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDataIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M10.586 21.9a1.93 1.93 0 0 1-1.414.583 1.93 1.93 0 0 1-1.415-.584l-5.656-5.656a1.93 1.93 0 0 1-.584-1.415q0-.83.584-1.414L13.414 2.101q.584-.585 1.414-.584.831 0 1.415.584l5.656 5.656q.584.584.584 1.415 0 .83-.584 1.414z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M9.172 20.485 20.485 9.172l-5.657-5.657-2.12 2.121 2.828 2.828L14.12 9.88l-2.827-2.83-1.414 1.414 2.828 2.829-1.414 1.414L8.464 9.88 7.05 11.293l2.83 2.827-1.415 1.415-2.828-2.829-2.121 2.121z"
}))));
export default SvgDataIcon;